<h1 i18n>Contribute submission</h1>
@if (showBreadcrumb) {
<nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb">
        @for (crumb of breadcrumb; track crumb; let index = $index) {
        <li class="breadcrumb-item" [ngClass]="{'active': index === activeBreadcrumb}">{{crumb.text}}</li>
        }
    </ol>
</nav>
}

@switch (status$ | async) {
@case ('loading') {
<p>Preparing submission process...</p>
<div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
</div>
}

@case ('nope') {
<div class="alert alert-danger" i18n>
    Unable to make a submission now. An error message might be available in the log. Please try again later.
</div>
}

@case ('ready') {
<p>
    <ng-container i18n>Your files will only be sent once you have fully completed the submission process.</ng-container>
    @if (encryptionActivated()) {
    <ng-container i18n>The files can only be accessed by the researcher.</ng-container>
    }
</p>
<p i18n>
    <a [routerLink]="['/', 'privacy']">Learn more about how we protect your privacy</a>.
<p>
    <ell-file-list [allowDelete]="true" [files]="files" (addFiles)="addFiles($event)"
        (deleteFile)="deleteFile($event)" />
    }

    @case ('survey') {
    <ell-survey [survey]="survey" />
    }

    @case ('review') {
<h2 i18n>Review Submission</h2>
<p>
    <ng-container i18n>Here you can see an overview of the files that will be submitted. You can add more, or click “confirm submission” to submit.</ng-container>
    @if (encryptionActivated()) {
    <ng-container i18n>The files can only be accessed by the researcher.</ng-container>
    }
</p>
<p i18n>
    <a [routerLink]="['/', 'privacy']">Learn more about how we protect your privacy</a>.
</p>
@if (!encryptionActivated()) {
<p>
    <button type="button" class="btn btn-light" (click)="editEmail()">
        {{email}}
        <fa-icon [icon]="faPencil"></fa-icon>
    </button>
</p>
}
<ell-file-list [allowDelete]="!countingDown" [files]="files" [readonly]="true" (deleteFile)="deleteFile($event)" />
<hr />
<h2 i18n>Confirmation</h2>
<div class="container">
    <ell-survey-question question="Do you want to upload any more data?" type="radio-select" [(answer)]="uploadMore"
        [options]="yesNo" name="uploadMore" i18n-question></ell-survey-question>

    @if (!countingDown && uploadMore === yesNo[0]) {
    <ell-file-dropzone (addFiles)="addFiles($event)" />
    }
    @else if (uploadMore === yesNo[1]) {
    <ell-confirm-submission (countingDown)="countingDown=$event" (submit)="submit()"></ell-confirm-submission>
    }
</div>
}

@case ('sending') {
<h2 i18n>Sending</h2>
@if (encryptionActivated()) {
<p i18n>The system is encrypting and sending your information. Please wait until this is done.</p>
} @else {
<p i18n>The system is sending your information. Please wait until this is done.</p>
}
<div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
</div>
}

@case ('complete') {
<h2 i18n>Complete</h2>
<p i18n>
    Thank you very much for your contribution.</p>
<h3 i18n>Overview of the Files</h3>
<p i18n>These files were sent, you can still inspect or download them here. They will be automatically removed from your
    browser once you close this page.</p>
<ell-file-list [files]="files" [readonly]="true" />
}
}
